import { z } from 'zod';
import { createToolSignature } from './tool-signature';
export const generateMessageToolSignature = createToolSignature({
    name: 'generateMessageTool',
    description: 'Generate a message',
    inputSchema: z.object({
        messages: z.array(
            z.object({
                role: z.enum(['system', 'user', 'assistant']),
                content: z.string(),
            }),
        ),
    }),
    outputSchema: z.object({
        message: z.object({
            content: z.string(),
            subjectLine: z.string(),
        }),
    }),
    toolCallUi: (input) => `Creating message`,
});
